<template>
    <div class="about">
        <chapter tag="h1" class="ribbon">{{ lesson.name }} {{ lesson.base_classe }}</chapter>
        <div v-if="topics.length">
            <router-link :to="{name: 'math-topic', params: {id: topic.id}}" v-for="(topic, index) in topics" :key="index">
                <div>
                    {{ topic.title }}
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    //import Vue from 'vue';
    //Vue.component('math-lessons', () => import(/* webpackChunkName: "math-lessons" */ '~/components/math-lessons'));

    export default {
        name: 'math-topics-page',
        data() {
            return {
                lesson: {},
                topics: [],
            };
        },
        mounted() {
            this.renderTopics();
        },
        methods: {
            renderTopics() {
                api.get(`public/topics?subject_id=${this.$route.query.subject_id}&base_classe=${this.$route.query.base_classe}`).then(response => {
                    this.lesson = response.data.lesson;
                    this.topics = response.data.topics;
                    //this.$emit('afterVideoSearch', this.packageItem);
                });
            }
        }
    }
</script>
